import { render, staticRenderFns } from "./completed-screen.vue?vue&type=template&id=d3d3729e&"
import script from "./completed-screen.vue?vue&type=script&lang=ts&"
export * from "./completed-screen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports